import clsx from 'clsx';
import { Link, LinkProps } from '@trg/tlw-ui-component';
import type { Category } from '../api';
import { useMenuStore } from '../stores';

export interface CategoryLinkProps {
  category: Category;
}

export function CategoryLink({ category }: CategoryLinkProps) {
  const setMenuOpen = useMenuStore.use.setMenuOpen();
  const selectedCategory = useMenuStore.use.selectedCategory();
  const setSelectedCategory = useMenuStore.use.setSelectedCategory();

  const isActive = category.title === selectedCategory?.title;
  const hasChildren = Boolean(category?.subCategories?.length);

  const handleClick: LinkProps['onClick'] = (e) => {
    hasChildren && e.preventDefault();
    setMenuOpen(true);
    setSelectedCategory(category);
  };

  return (
    <Link
      className={clsx(
        'tlw-relative tlw-block tlw-duration-300 tlw-whitespace-nowrap tlw-cursor-pointer',
        'tlw-txt-zh-head-6 tlw-text-txt-700 tlw-mx-1 tlw-px-1 tlw-py-5',
        'lg:tlw-text-txt-800 lg:tlw-mx-0 lg:tlw-px-3 lg:tlw-py-4',
        'after:tlw-absolute after:tlw-left-0 after:tlw-bottom-0 after:tlw-h-[2px] after:tlw-w-full after:tlw-bg-pr after:tlw-origin-left after:tlw-scale-x-0 after:tlw-duration-[600ms]',
        'hover:tlw-text-txt-core hover:after:tlw-scale-x-100',
        isActive && 'tlw-text-txt-800 after:tlw-scale-x-100'
      )}
      style={category.titleTextColor ? { color: category.titleTextColor } : {}}
      href={category.titleLink}
      title={category.title}
      onClick={handleClick}
    >
      {category.title}
    </Link>
  );
}
